import {
    openEditor,
    createDefaultImageReader,
    createDefaultImageWriter,
    createDefaultImageOrienter,
    processImage,
    // plugins
    setPlugins,
    plugin_crop,
    plugin_filter,
    getEditorDefaults
} from "@pqina/pintura";
import locale_es from '@pqina/pintura/locale/es_ES';

import * as FilePond from 'filepond';
import FilePondPluginFilePoster from "filepond-plugin-file-poster";
import FilePondPluginImageEditor from "@pqina/filepond-plugin-image-editor";
import gsap from 'gsap';
import ModalPhotos from "./modal-photos";
import LottieLoader from "./lottie-loader";
FilePond.registerPlugin(
    FilePondPluginImageEditor,
    FilePondPluginFilePoster
)
// pintura
setPlugins(plugin_crop, plugin_filter);

locale_es.labelButtonExport = "Finalizar"

class ImageUploader {
    constructor(file, totalFiles) {
        this.file = file;
        this.totalFiles = totalFiles;
        this.uploadedFiles = 0;
        this.currentFileProgress = 0;
        this.progressBar = document.querySelector('#upload-progress-bar');
        this.fileProgress = 0;
    }

    updateProgress(fileProgress) {
        this.fileProgress = fileProgress;
        const progressPerFile = 100 / this.totalFiles;
        const globalProgress = (this.uploadedFiles * progressPerFile) + (this.fileProgress * progressPerFile);
        this.updateProgressBar(globalProgress);
    }

    fileCompleted() {
        this.uploadedFiles++;
        this.fileProgress = 0;
    }

    updateProgressBar(percentage) {
        if (this.progressBar) {
            this.progressBar.style.width = `${percentage}%`;
            this.progressBar.innerText = `${Math.round(percentage)}%`;
        }
    }

    upload() {
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('photo', this.file, this.file.name);

            const request = new XMLHttpRequest();
            request.open('POST', '/photos/upload', true);
            request.setRequestHeader("X-CSRF-Token", CSRF_TOKEN);

            request.upload.onprogress = (e) => {
                if (e.lengthComputable) {
                    const fileProgress = e.loaded / e.total;
                    this.updateProgress(fileProgress);
                }
            };

            request.onload = () => {
                if (request.status >= 200 && request.status < 300) {
                    this.fileCompleted();
                    resolve(request.responseText);
                } else {
                    reject('Error al subir el archivo');
                }
            };

            request.onerror = () => {
                reject('Error en la conexión');
            };

            request.send(formData);
        });
    }
}

FilePond.setOptions({
    labelInvalidField: "El campo contiene archivos inválidos",
    labelFileWaitingForSize: "Procesando dimensiones",
    labelFileSizeNotAvailable: "Tamaño no disponible",
    labelFileCountSingular: "archivo in lista",
    labelFileCountPlural: "archivos en lista",
    labelFileLoading: "Cargando",
    labelFileAdded: "Añadida",
    labelFileLoadError: "Error al cargar",
    labelFileRemoved: "Eliminado",
    labelFileRemoveError: "Error durante la eliminación",
    labelFileProcessingRevertError: "Error durante el revert",
    labelIdle: 'Suelta aquí tus imágenes o <span class="filepond--label-action">Selecciona desde tu dispositivo</span>',
    labelFileProcessing: 'Subiendo...',
    labelFileProcessingComplete: 'Subida completa',
    labelFileProcessingAborted: 'Subida cancelada',
    labelFileProcessingError: 'Error durante la subida',
    labelTapToCancel: 'Toca para cancelar',
    labelTapToRetry: 'Toca para reintentar',
    labelTapToUndo: 'Toca para deshacer',
    labelButtonRemoveItem: 'Eliminar',
    labelButtonAbortItemLoad: 'Abortar',
    labelButtonRetryItemLoad: 'Reintentar',
    labelButtonAbortItemProcessing: 'Cancelar',
    labelButtonUndoItemProcessing: 'Deshacer',
    labelButtonRetryItemProcessing: 'Reintentar',
    labelButtonProcessItem: 'Subir',
    labelMaxFileSizeExceeded: 'El archivo es demasiado grande',
    labelMaxFileSize: 'El tamaño máximo del archivo es {filesize}',
    labelMaxTotalFileSizeExceeded: 'El tamaño total de los archivos excede el límite',
    labelMaxTotalFileSize: 'El tamaño total máximo de los archivos es {filesize}',
    labelFileTypeNotAllowed: 'Solo se permiten archivos de imagen',
    fileValidateTypeLabelExpectedTypes: 'Solo se permiten archivos de imagen',
    // Configuración global para restringir solo imágenes
    acceptedFileTypes: ['image/*'],
    allowFileTypeValidation: true,
    imageValidateSizeLabelFormatError: 'El tipo de imagen no es compatible',
    imageValidateSizeLabelImageSizeTooSmall: 'La imagen es demasiado pequeña',
    imageValidateSizeLabelImageSizeTooBig: 'La imagen es demasiado grande',
    imageValidateSizeLabelExpectedMinSize: 'El tamaño mínimo es {minWidth} x {minHeight}',
    imageValidateSizeLabelExpectedMaxSize: 'El tamaño máximo es {maxWidth} x {maxHeight}',
    imageValidateSizeLabelImageResolutionTooLow: 'La resolución es demasiado baja',
    imageValidateSizeLabelImageResolutionTooHigh: 'La resolución es demasiado alta',
    server: {
        process: (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
            const formData = new FormData();
            formData.append(fieldName, file, file.name);

            const request = new XMLHttpRequest();
            request.open('POST', '/photos/upload', true);
            request.setRequestHeader("X-CSRF-Token", CSRF_TOKEN);

            // Variables para el progreso global
            const pond = FilePond.find(document.querySelector('.input-files'));
            const totalFiles = pond.getFiles().length;
            let uploadedFiles = 0;
            let currentFileProgress = 0;
            let previousFileProgress = 0;
            let highestProgress = 0;

            // Mostrar la animación Lottie solo al comenzar la primera carga
            const photoEditor = window.photoEditor;
            if (photoEditor && !photoEditor.lottieShown) {
                photoEditor.showLottieAnimation();
                photoEditor.lottieShown = true;
                console.log('Lottie animation started');
            }

            // Actualizar el progreso global
            request.upload.onprogress = (e) => {
                if (e.lengthComputable) {
                    const fileProgress = e.loaded / e.total;
                    progress(true, e.loaded, e.total);

                    // Detectar si es un nuevo archivo
                    if (fileProgress < previousFileProgress) {
                        uploadedFiles++;
                    }
                    previousFileProgress = fileProgress;
                    // Calcular el progreso global acumulativo
                    currentFileProgress = fileProgress;
                    const progressPerFile = 100 / totalFiles;
                    const globalProgress = (uploadedFiles * progressPerFile) + (currentFileProgress * progressPerFile);
                    
                    // Mantener el valor más alto entre el progreso actual y el previo
                    highestProgress = Math.max(highestProgress, globalProgress);
                    updateGlobalProgress(highestProgress);
                }
            };

            request.onload = function () {
                if (request.status >= 200 && request.status < 300) {
                    uploadedFiles++;
                    currentFileProgress = 0;
                    previousFileProgress = 0;
                    load(request.responseText);
                    
                    console.log(`File uploaded: ${uploadedFiles}/${totalFiles}`);
                    
                    // Ocultar la animación Lottie solo cuando se complete toda la carga
                    if (photoEditor && uploadedFiles >= totalFiles) {
                        setTimeout(() => {
                            photoEditor.hideLottieAnimation();
                            photoEditor.lottieShown = false;
                            console.log('Lottie animation completed');
                        }, 500); // Pequeño delay para mostrar que se completó
                    }
                } else {
                    error('Error al subir el archivo');
                    // Ocultar la animación Lottie en caso de error
                    if (photoEditor) {
                        photoEditor.hideLottieAnimation();
                        photoEditor.lottieShown = false;
                        console.log('Lottie animation error');
                    }
                }
            };

            request.onerror = function () {
                error('Error en la conexión');
                // Ocultar la animación Lottie en caso de error
                if (photoEditor) {
                    photoEditor.hideLottieAnimation();
                    photoEditor.lottieShown = false;
                    console.log('Lottie animation connection error');
                }
            };

            request.send(formData);

            return {
                abort: () => {
                    request.abort();
                    abort();
                    // Ocultar la animación Lottie si se cancela
                    if (photoEditor) {
                        photoEditor.hideLottieAnimation();
                        photoEditor.lottieShown = false;
                        console.log('Lottie animation aborted');
                    }
                },
            };
        },
    },
});

function updateGlobalProgress(percentage) {
    const progressBar = document.querySelector('#upload-progress-bar');
    if (progressBar) {
        progressBar.style.width = `${percentage}%`;
        progressBar.innerText = `${Math.round(percentage)}%`;
    }
}

export default class PhotoEditor {
    constructor() {
        const DPI = 300;
        // FIX: TODO. Revisar conversión para salida a impresión. Revisar plugin de escalado, resize. Seteo de px y calidad en export
        this.width = Math.round(PHOTO_WIDTH * (DPI / 2.54));
        this.height = Math.round(PHOTO_HEIGHT * (DPI / 2.54));

        this.aspect_ratio = ASPECT_RATIO;
        let pond = document.querySelector('.input-files')
        if (!pond) return ".input-files es requerido en el DOM"
        
        // Inicializar el loader Lottie para el proceso de carga
        this.initLottieLoader();
        
        this.initFilePond(pond);
    }

    initLottieLoader() {
        // Crear un contenedor para la animación Lottie si no existe
        let lottieContainer = document.querySelector('#lottie-upload-container');
        if (!lottieContainer) {
            lottieContainer = document.createElement('div');
            lottieContainer.id = 'lottie-upload-container';
            lottieContainer.className = 'w-full hidden flex flex-col items-center justify-center py-8';
            document.body.appendChild(lottieContainer);
        }
        
        this.lottieLoader = new LottieLoader(
            lottieContainer,
            LottieLoader.getDefaultUploadAnimation()
        );
        this.lottieLoader.init();
        
        // Inicializar el estado de la animación
        this.lottieShown = false;
    }

    initFilePond(container) {
        // Verificar si estamos en una página de fotobooks
        const isFotobookPage = document.getElementById('fotobook-selection-section');
        if (isFotobookPage) {
            console.log('PhotoEditor: Skipping FilePond initialization on fotobook page');
            return;
        }

        // Verificar si el contenedor existe
        if (!container) {
            console.log('PhotoEditor: No container found for FilePond');
            return;
        }

        // Verificar si ya existe una instancia de FilePond
        const existingPond = FilePond.find(container);
        if (existingPond) {
            console.log('PhotoEditor: FilePond already initialized');
            this.pond = existingPond;
            return;
        }

        this.pond = FilePond.create(container, {
            allowImageEditor: true,
            allowImagePreview: true,
            imageEditorSupportEdit: true,
            imageEditorWriteImage: true,
            imageEditorLoadImage: true,
            allowMultiple: true,
            allowReorder: false,
            allowFilePoster: true,
            filePosterMaxHeight: 256,
            imagePreviewHeight: 256,
            imageResizeTargetWidth: 200,
            imageResizeTargetHeight: 200,
            instantUpload: false,
            credits: false,
            forceRevert: true,
            imageEditInstantEdit: false,
            allowImagePreview: false,
            allowImageExifOrientation: false,
            // Restringir solo a tipos de imagen
            acceptedFileTypes: ['image/*'],
            allowFileTypeValidation: true,
            fileValidateTypeLabelExpectedTypes: 'Solo se permiten archivos de imagen',
            // Validador personalizado para asegurar que solo se acepten imágenes
            fileValidateTypeFilter: (file) => {
                return file.type.startsWith('image/');
            },
            // server: this.getFilePondServerConfig(),
            imageEditor: this.getImageEditor()
        });
        this.modal = new ModalPhotos(this);

        // Manejar el evento cuando se agrega un archivo
        this.pond.on('warning', (error, file) => {
            // Verificar si se excede el límite de fotos permitidas
            const counter = file.length + this.pond.getFiles().length
            if (counter > TOTAL_PHOTOS) {
                this.showAlert(`Sólo puedes seleccionar ${TOTAL_PHOTOS} imágenes.`);
                return;
            }
        })
        this.pond.on('addfile', (error, file) => {
            // Verificar que el archivo sea una imagen
            if (!file.file.type.startsWith('image/')) {
                this.showAlert('Solo se permiten archivos de imagen (JPG, PNG, GIF, etc.)');
                this.pond.removeFile(file);
                return;
            }
            
            this.checkImageResolution(file.file);
            this.updatePhotosCounter();
            this.togglePrintButton();
            
            // Resetear el estado de la animación cuando se agrega un nuevo archivo
            this.resetLottieState();
        });

        this.pond.on('removefile', () => {
            this.updatePhotosCounter();
            this.togglePrintButton();
            
            // Resetear el estado de la animación cuando se elimina un archivo
            this.resetLottieState();
        })

        // Listener para cuando FilePond inicia el procesamiento
        this.pond.on('processfiles', () => {
            console.log('FilePond: Starting to process files');
            if (!this.lottieShown) {
                this.showLottieAnimation();
            }
        });

        // Listener para cuando FilePond completa el procesamiento
        this.pond.on('processfilesdone', () => {
            console.log('FilePond: Finished processing files');
            setTimeout(() => {
                this.hideLottieAnimation();
            }, 500);
        });

        // Listener para cuando FilePond tiene errores
        this.pond.on('processfileserror', () => {
            console.log('FilePond: Error processing files');
            this.hideLottieAnimation();
        });

        // Manejar errores de validación de tipo de archivo
        this.pond.on('error', (error, file) => {
            if (error.code === 'FILE_TYPE_NOT_ALLOWED') {
                this.showAlert('Solo se permiten archivos de imagen (JPG, PNG, GIF, etc.)');
            }
        });

        const printButton = document.querySelector('#to-review-btn');
        if (printButton) {
            printButton.addEventListener("click", (e) => {
                e.preventDefault()
                this.modal.open()
            })
        }

        setTimeout(() => {
            this.configureInputAccept();
        }, 1000);
    }

    configureInputAccept() {
        // Buscar el input file generado por FilePond y configurar el atributo accept
        const fileInput = document.querySelector('input.filepond--browser');
        if (fileInput) {
            fileInput.setAttribute('accept', 'image/*');
        }
    }

    get selectedFiles() {
        const pond = FilePond.find(document.querySelector('.input-files'));
        return this.pond.getFiles();
    }

    getFileById(fileId) {
        const file = this.selectedFiles.find((file) => file.id === fileId);
        return file ? file : null; // Retorna el archivo si se encuentra
    }

    togglePrintButton() {
        const printButton = document.querySelector('#to-review-btn');
        if (!printButton) return; // Salir si no existe el botón
        
        if (this.selectedFiles.length === TOTAL_PHOTOS) {
            printButton.classList.remove('hidden');
            printButton.classList.remove('disabled');
        } else {
            printButton.classList.add('hidden');
            printButton.classList.add('disabled');
        }
    }

    checkImageResolution(file) {
        const reader = new FileReader();
        reader.onload = (event) => {
            const img = new Image();
            img.onload = () => {
                const minWidth = this.width; // Resolución mínima en píxeles
                const minHeight = this.height; // Resolución mínima en píxeles

                if (img.width < minWidth || img.height < minHeight) {
                    this.showAlert(`Para una impresión de calidad tus imágenes deben medir al menos ${minWidth}x${minHeight}px.`);
                }
            };
            img.src = event.target.result;
        };
        reader.readAsDataURL(file);
    }

    getImageEditor() {
        return {
            // used to create the editor, receives editor configuration, should return an editor instance
            createEditor: openEditor,
            // Required, used for reading the image data
            acceptedFileTypes: ['image/*'],
            imageReader: [createDefaultImageReader],
            // optionally. can leave out when not generating a preview thumbnail and/or output image
            imageWriter: [
                createDefaultImageWriter,
                // optional image writer instructions, this instructs
                // the image writer to resize the image to match a width of 384 pixels
                {
                    targetSize: {
                        width: this.width,
                        height: this.height,
                    },
                    mimeType: 'image/jpeg', // Asegurar que el archivo sea JPEG
                    quality: 0.9, // Calidad de la imagen (90%)
                },
            ],
            // used to generate poster images, runs an editor in the background
            imageProcessor: processImage,
            // Pintura Image Editor properties
            editorOptions: {
                // pass the editor default configuration options
                ...getEditorDefaults(),
                utils: ["crop", "filter", "flip", "rotate"],
                imageOrienter: createDefaultImageOrienter(),
                imageCropAspectRatio: ASPECT_RATIO, // Mantener el mismo radio de aspecto
                enableCropAspectRatioSelection: true, // Deshabilitar la selección de proporción de recorte
                locale: locale_es
            },
        }
    }

    showAlert(_msg) {
        let msg = document.querySelector("#editor-alert-message")
        if (!msg) return; // Salir si no existe el elemento de alerta
        
        this.delay_message = 2
        msg.innerText = _msg
        gsap.set("#editor-alert", {
            display: "hidden",
            opacity: 0,
            y: 15
        })
        gsap.to("#editor-alert", {
            display: "flex",
            ease: "back.out(.7)",
            duration: .45,
            opacity: 1,
            y: 0,
            onComplete: () => {
                gsap.to("#editor-alert", {
                    display: "hidden",
                    ease: "back.in(.7)",
                    duration: .45,
                    delay: this.delay_message,
                    opacity: 0,
                    y: -15
                })
            }
        })
    }

    showLottieAnimation() {
        if (this.lottieLoader) {
            this.lottieLoader.show();
            this.lottieShown = true;
            console.log('Lottie animation shown');
        }
    }

    hideLottieAnimation() {
        if (this.lottieLoader) {
            this.lottieLoader.hide();
            this.lottieShown = false;
            console.log('Lottie animation hidden');
        }
    }

    resetLottieState() {
        this.lottieShown = false;
        if (this.lottieLoader) {
            this.lottieLoader.hide();
        }
        console.log('Lottie state reset');
    }

    startUploadProcess() {
        // Resetear el estado y mostrar la animación al iniciar un nuevo proceso
        this.resetLottieState();
        if (this.lottieLoader) {
            this.lottieLoader.show();
            this.lottieShown = true;
            console.log('Upload process started with Lottie');
        }
    }

    completeUploadProcess() {
        // Ocultar la animación cuando se complete todo el proceso
        if (this.lottieLoader) {
            this.lottieLoader.hide();
        }
        this.lottieShown = false;
        console.log('Upload process completed');
    }

    // Método de prueba para verificar la animación
    testLottieAnimation() {
        console.log('Testing Lottie animation...');
        console.log('Current state:', this.lottieShown);
        console.log('LottieLoader exists:', !!this.lottieLoader);
        
        if (this.lottieLoader) {
            this.showLottieAnimation();
            setTimeout(() => {
                this.hideLottieAnimation();
                console.log('Test completed');
            }, 3000);
        }
    }

    updatePhotosCounter() {
        const photosCounter = document.querySelector('#photos-selected-counter');
        if (!photosCounter || !this.pond) return; // Salir si no existe el contador o el pond
        
        photosCounter.innerText = this.pond.getFiles().length; // Actualizar el texto del contador
    }
}